<div class="block min-h-dvh">
  <app-loading-overlay />
  <app-global-toast />
  <app-global-confirm-dialog />
  <router-outlet />
</div>
